export const SET_BILL = 'setBill';
export const SET_NUMBER_OF_PEOPLE = 'setNumberOfPeople';
export const SET_TIP_PERCENTAGE = 'setTipPercentage';
export const RESET = 'reset';
